import {connect} from 'react-redux';
import {push} from 'react-router-redux/lib/actions';
import { STREAM_ROUTER_ROOT, STREAM_ROUTER_EDIT, STREAM_ROUTER_LIVE} from './../constants';
import StreamViewComponent from './StreamView';
import {streamAction} from '../../../../actions/stream/liveStadiumStream';
import { listDispatchFromCrud } from '../../../../selectors/crud';
// new way of actions. Has to have less memory in use;
let CRUDActions = streamAction;

export default connect(
  ({liveStadiumStream: {loadingItem, model}}) => ({
    model,
    title: 'View Stream',
    loading: loadingItem,
  }),
  dispatch => ({
    ...listDispatchFromCrud(dispatch, streamAction),
    fetch: (id) => dispatch(CRUDActions.fetch(id)),
    delete: async (model) => await dispatch(CRUDActions.remove(model)),
    onClose: () => dispatch(push(STREAM_ROUTER_LIVE)),
    goIndex: () => dispatch(push(STREAM_ROUTER_LIVE)),
    goEdit: (id) => dispatch(push(STREAM_ROUTER_EDIT.replace(':id', id))),
  })
)(StreamViewComponent)





// WEBPACK FOOTER //
// ./src/components/Stream/LiveStream/StreamView/index.js